import { render, staticRenderFns } from "./ContactUsPage.vue?vue&type=template&id=b0e29860&scoped=true"
import script from "./ContactUsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUsPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e29860",
  null
  
)

export default component.exports